import {MeetingCommentFile} from './MeetingCommentFile'
import {NatAsyncCallFunction} from '../../../__NoAutomatedTests/common/util/Natutil'
import {MeetingRepositoryForResident} from '../MeetingRepositoryForResident'
import NewMeetingComment from './NewMeetingComment'
import {InputError} from '../components/MeetingCommentInputForm'
import EventEmitterEx from '../../shared/pageBaseComponents/EventEmitterEx'
import {Nullable} from '../../../app/TypeHelpers'
import {SubmitCommentAndFilesTemplateForResident} from './SubmitCommentAndFilesTemplateForResident'
import {FileDataForValidate} from './FileDataForValidate'
import {NavigateFunction} from 'react-router-dom'

interface SendData {
    condominiumCd: string
    meetingId: number
    newMeetingComment: NewMeetingComment
}

export class SubmitNewCommentProcedure extends SubmitCommentAndFilesTemplateForResident<SendData> {
    meetingRepoForResident: MeetingRepositoryForResident
    navigate: NavigateFunction

    constructor(
        registerCommentError: (inputError: InputError) => void,
        meetingRepoForResident: MeetingRepositoryForResident,
        eventEmitter: EventEmitterEx,
        navigate: NavigateFunction,
    ) {
        super(registerCommentError, eventEmitter)
        this.meetingRepoForResident = meetingRepoForResident
        this.navigate = navigate
    }

    async innerRegisterComment(sendData: SendData): Promise<Nullable<number>> {
        return await NatAsyncCallFunction(
            this.meetingRepoForResident.registerComment.bind(
                this.meetingRepoForResident,
                sendData.condominiumCd,
                sendData.meetingId,
                sendData.newMeetingComment,
            ),
            this.navigate,
        )
    }

    async innerValidateFile(fileDataForValidate: FileDataForValidate): Promise<Nullable<void>> {
        return await NatAsyncCallFunction(
            this.meetingRepoForResident.validateParallelFileUpload.bind(
                this.meetingRepoForResident,
                fileDataForValidate,
            ),
            this.navigate,
        )
    }

    async registerFile(sendData: SendData, commentId: number, commentFile: MeetingCommentFile): Promise<void> {
        // NatAsyncCallFunctionによる標準の通信エラー処理を行わない
        // 原因はなんであれファイルを再登録する必要があることをユーザーに伝える必要があるため、全ての例外を捕捉する
        await this.meetingRepoForResident.registerCommentFile(
            sendData.condominiumCd,
            sendData.meetingId,
            commentId,
            commentFile,
        )
    }

    async submit(
        condominiumCd: string,
        meetingId: number,
        newMeetingComment: NewMeetingComment,
        commentFileList: MeetingCommentFile[],
    ): Promise<Nullable<number>> {
        this.commentId = null
        await this.process(
            {
                condominiumCd: condominiumCd,
                meetingId: meetingId,
                newMeetingComment: newMeetingComment,
            },
            commentFileList,
        )

        return this.commentId
    }
}
